import DefaultContentBlock from './DefaultContentBlock';

export default DefaultContentBlock;
